<div class="form-grid-container mt-3">
  <div class="">
    <form [formGroup]="requestForm">
      <ng-container class="row mt-3" formArrayName="sections">
        <ng-container
          *ngFor="let section of sectionsArray.controls; let i = index"
        >
          <ng-container [formGroupName]="i">
            <div class="row">
              <ng-container formArrayName="childern">
                <div
                   [ngClass]="item.get('name').value === 'CX' ? 'col-sm-12' : 'col-sm-6'"
                  [formGroupName]="j"
                  *ngFor="let item of getChildern(section); let j = index"
                >
                <div class="card">
                  <div class="card-header">
                      {{ item.get("name").value }}
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-6">
                          <dx-number-box [inputAttr]="{ autocomplete: 'off' }" 
                          [step]="0.25"
                          placeholder="Min"
                            formControlName="min"
                      >
                      <dx-validator>
                          <dxi-validation-rule 
                              type="required"
                              message="Min required">
                          </dxi-validation-rule>
                          </dx-validator>
                    </dx-number-box>
                      </div>
                      <div class="col-sm-6">
                          <dx-number-box [inputAttr]="{ autocomplete: 'off' }" 
                          [step]="0.25"
                          placeholder="Max"
                            formControlName="max"
                      >
                      <dx-validator>
                          <dxi-validation-rule 
                              type="required"
                              message="Max required">
                          </dxi-validation-rule>
                          </dx-validator>
                    </dx-number-box>
                      </div>
                    </div>
                  </div>
                </div>
                  <!-- <fieldset>
                    <legend>
                      {{ item.get("name").value }}
                      <small class="text-muted">Range</small>
                    </legend>
                  
                    <div class="row p-20">
                        <div class="col-sm-6">
                            
                        <mat-form-field class="w-100">
                          <input
                            type="number"
                            matInput
                            placeholder="Min"
                            step="0.25"
                            formControlName="min"
                            required
                            autocomplete="off"
                          />
                          <mat-hint>min -15 </mat-hint>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-6">
                        <mat-form-field class="w-100">
                          <input
                            type="number"
                            matInput
                            placeholder="Max"
                            step="0.25"
                            formControlName="max"
                            required
                            autocomplete="off"
                          />
                          <mat-hint>max 15</mat-hint>
                        </mat-form-field>
                      </div>
                    </div>
                  </fieldset> -->
                  <div class="row clearfix">
                    <div class="col-sm-12 mt-3 mb-3">
                       <div class="float-right">
                        <div *ngIf="getCxTypeDetail(section).length > 0 && item.get('name').value === 'CX';then clearBtn;else generateBtn"></div>
                        <ng-template #clearBtn>
                            <dx-button 
                            id="add-row"
                            text="Add Rows"
                            type="normal"  
                            class="mr-2"
                            (click)="addRows()" 
                            >
                          </dx-button>
                            <!-- <button
                            type="button"
                            color="info"
                            class="p-2 mr-2"
                            mat-raised-button 
                            (click)="addRows()"
                    >
                      Add Rows
                    </button> -->
                    <dx-button text="Clear Range"  type="danger" class="float-right" (click)="clearField()"></dx-button>
                    <!-- <dx-button text="Clear Range" *ngIf="!isEdit" type="danger" class="float-right" (click)="clearField()"></dx-button> -->
                        </ng-template>
                        <ng-template #generateBtn>
                            <dx-button 
                            id="button"
                            text="Generate Range"
                            *ngIf="(item.get('min').value  && item.get('max').value) && item.get('name').value === 'CX' || (item.get('min').value === 0 && item.get('max').value) "
                            type="default"  
                            class="float-right ml-3"
                            (click)="generateGrid(item.get('min').value, item.get('max').value)" 
                            >
                          </dx-button>
                          <!-- <button
                                  color="primary" type="button"
                                  *ngIf="(item.get('min').value  && item.get('max').value) && item.get('name').value === 'CX' || (item.get('min').value === 0 && item.get('max').value) "
                                  class="p-2"
                                  mat-raised-button
                                  (click)="generateGrid(item.get('min').value, item.get('max').value)"
                          >
                            Generate Range
                          </button> -->

                        </ng-template>
                      </div> 
                    </div>
                  </div>
                </div>

              </ng-container>
            </div>

          

        
      <!-- <span class="total-count">Total: {{total}}</span> -->
      <div class="clearfix"></div>
      <div class="row mt-2" *ngIf="getCxTypeDetail(section).length > 0">
        <div class="col">
          <div class="card animated fadeIn">
            <div class="card-body pb-0">
                <div class="table-responsive-sm">
                  <ng-container formArrayName="cxTypeDetail">
                    <dx-data-grid
                      class="cx-grid"
                      [dataSource]="gridData"
                      [columns]="gridColumns"
                      keyExpr="_index"
                      [showBorders]="true"
                      [columnAutoWidth]="true"
                      [rowAlternationEnabled]="true"
                      [hoverStateEnabled]="true"
                      [allowColumnResizing]="true"
                      [editing]="{ mode: 'cell', allowUpdating: true, allowDeleting: true, useIcons: true }"
                      (onCellValueChanged)="onGridCellValueChanged($event)"
                      (onRowRemoving)="onGridRowRemoving($event)"
                      (onSaving)="onGridSaving($event)"
                      (onEditorPreparing)="onGridEditorPreparing($event)">
                    </dx-data-grid>
                  </ng-container>
                </div>
            </div>
          </div>
        </div>
      </div>
      <dx-popover position="top" [width]="150" [showTitle]="true" title="Remarks Preview"
      [(visible)]="actionSheetVisible" [target]="popupTarget" [hideOnOutsideClick]="true">
      <div *dxTemplate="let data = model of 'content'">
        {{userRemarks}}
      </div>
    </dx-popover>
      <div class="row mt-2">
       
          <div class="col  animated fadeInUp" *ngIf="validateSubmitBtn">
            <!--<div class="float-left mt-2" *ngIf="isEdit">
                Active <dx-check-box formControlName="isActive"></dx-check-box>
              </div>-->
              <dx-button 
                id="button"
                [text]="isEdit ? 'Update':  'Save'"
                type="default"  
                class="float-right ml-3"
                
                (click)="!requestForm.valid || saveStockRequest(requestForm)"
                [useSubmitBehavior]="true">
            </dx-button>
            <dx-button text="Cancel" type="normal" class="float-right" appBackButton>
            </dx-button>
            <!-- <button
              class="btn float-right btn-primary hvr-glow"
              type="submit" *ngIf="getCxTypeDetail(section).length > 0 ||  section.get('condition').value == 1 || section.get('condition').value == 2"  
            >
              Save</button
            ><button
              class="btn float-right mr-3 btn-secondary hvr-glow"
              type="button"
              appBackButton
            >
              Cancel
            </button> -->
          </div>
      </div>
    </ng-container>
    </ng-container>

  </ng-container>
    </form>
  </div>
</div>
